import { useParams, useOutletContext, Link } from "react-router-dom";

import './BiokemShow.css';
import {translations} from './../../i18/translations.js';

const BiokemShow = () => {
    const {year, index, title} = useParams();
    const {lang} = useOutletContext();
    const RESOURCES_DIR = process.env.REACT_APP_RESOURCES_DIR;
    const pdfUrl = RESOURCES_DIR + "/biokem/" + year + "/" + year + "_" + index + ".pdf";
    return (
            <div className="mbkegy-content">
                <h1 className="mbkegy-content">{year}. {translations[lang][title]}</h1>
            
                <p className="link-row">
                    <Link className="content-view-link" to={`/Biokem/${year}`}>
                    {translations[lang].back}
                    </Link>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <Link  className="content-view-link" to={`/${RESOURCES_DIR}/biokem/${year}/${year}_${index}.pdf`} target="_blank" rel="noopener noreferrer">
                    {translations[lang].open_in_new_win}
                    </Link>
                </p>
                <div className="content-pdf-viewer">
                    <iframe
                        src={`/${RESOURCES_DIR}/biokem/${year}/${year}_${index}.pdf`}
                        frameBorder="0" />
                </div>
            </div>
            );
};
export default BiokemShow;
